.root {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1);
  width: 100%;
}

.columnLabels {
  display: flex;
  justify-content: space-around;
  font-weight: 600;
  font-size: var(--tuna-typography-body-fontSize);
  color: var(--tuna-content-primary);
}

.svg {
  width: 100%;
  height: 12rem;
  background: var(--tuna-surface-elevated, var(--tuna-palette-grey-100));
  border-radius: var(--tuna-shape-borderRadius);
  border: 1px solid var(--tuna-border-subtle, var(--tuna-palette-grey-300));
}

/*
 * Three distinct lane fills so Bass / Middle / Top read apart at a glance
 * (the 3rd-on-top vs 5th-on-top pedagogical hook). The earlier info-300/500/700
 * tokens do not exist in the theme, so bass and mid both collapsed to info-main
 * — making two of the three voices identical. Use the real teal ramp instead.
 */
.voiceBass rect {
  fill: var(--tuna-palette-info-light);
}

.voiceMid rect {
  fill: var(--tuna-palette-info-main);
}

.voiceTop rect {
  fill: var(--tuna-palette-info-dark);
}

.commonToneHeld {
  stroke: var(--tuna-feedback-success, var(--tuna-palette-success-main));
  stroke-width: 2;
}

.step {
  stroke: var(--tuna-content-secondary);
  stroke-width: 1.5;
}

.leap {
  stroke: var(--tuna-feedback-warning, var(--tuna-palette-warning-main));
  stroke-width: 1.5;
  stroke-dasharray: 3 2;
}

.columns {
  display: flex;
  justify-content: space-around;
  font-family: var(--tuna-typography-mono-fontFamily, monospace);
  font-size: var(--tuna-typography-body2-fontSize);
}

.column {
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  gap: var(--tuna-spacing-1);
  color: var(--tuna-content-secondary);
}

.empty {
  color: var(--tuna-content-muted);
  font-size: var(--tuna-typography-body2-fontSize);
  padding: var(--tuna-spacing-2);
}
